import { useTrend, UseTrendReturn } from './useTrend';
import { getDriverArrivedTrend, TrendTimeframeGrain } from '../services/completedTrendApi';
import type { AppliedFiltersSnapshot } from '../OnTimeDispatchDashboard';

export type UseDriverArrivedTrendReturn = UseTrendReturn;

export function useDriverArrivedTrend(
  appliedFilters: AppliedFiltersSnapshot,
  timeframeGrain: TrendTimeframeGrain
): UseDriverArrivedTrendReturn {
  return useTrend(getDriverArrivedTrend, 'Driver Arrived as Expected % Trend', appliedFilters, timeframeGrain);
}
